import { MapPin, Building2, Mailbox } from "lucide-react";
import { Input, Select } from "@/components/ui";
import { LocationType } from "../types/LocationType";

type LocalizacionFiltroProps = {
  filterType: LocationType;
  filterValue: string;
  onTypeChange: (v: LocationType) => void;
  onValueChange: (v: string) => void;
};

const LocalizacionFiltro = ({
  filterType,
  filterValue,
  onTypeChange,
  onValueChange,
}: LocalizacionFiltroProps) => {
  const icon =
    filterType === "localidad" ? (
      <MapPin size={18} />
    ) : filterType === "provincia" ? (
      <Building2 size={18} />
    ) : (
      <Mailbox size={18} />
    );

  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto items-center mt-4">
      {/* Select */}
      <div className="relative">
        <Select
          value={filterType}
          onChange={(e) => onTypeChange(e.target.value as LocationType)}
          options={[
            { value: "localidad", label: "Localidad" },
            { value: "provincia", label: "Provincia" },
            { value: "provincia-localidad", label: "Localidades-Provincia" }, // NUEVO
            { value: "codigo_postal", label: "Código postal" },
          ]}
          className="appearance-none px-4 py-2 pr-10 rounded-xl border border-gray-300 bg-white shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-black"
        />

      </div>

      {/* Input */}
      <div className="relative w-full sm:w-64">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          {icon}
        </span>
        <Input
          value={filterValue}
          onChange={(e) => onValueChange(e.target.value)}
          placeholder="Filtrar por ubicación..."
          className="w-full pl-10 pr-4 py-2 rounded-xl border border-gray-300 shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>
    </div>
  );
};

export default LocalizacionFiltro;
